<template
  ><span>
    <div v-for="(item, index) in items" :key="index" class="dl">
      <div class="dt">
        <div class="input-checkbox">
          <input
            :id="item.id"
            v-model="data.values"
            :name="item.id"
            type="checkbox"
            :value="item.id"
          />
          <span class="checkmark"></span>
        </div>
      </div>
      <div class="dd">
        <label :for="item.id">{{ item.text }}</label>
      </div>
    </div>
    <ErrorPopup
      @closeErrorPopup="closeErrorPopup"
      v-show="data.errors"
      text="Выберите один или несколько ответов."
    />
  </span>
</template>

<script>
import ErrorPopup from "@/components/feedback/ErrorPopup";
export default {
  name: "Checkbox",
  components: { ErrorPopup },
  data: () => {
    return {
      data: {
        values: [],
        errors: 0
      }
    };
  },
  props: {
    items: {
      type: Array,
      default: () => []
    },
    other: {
      type: Boolean,
      default: () => false
    },
    questionId: {
      type: Number,
      default: () => 0
    },
    isRequired: {
      type: Boolean,
      default: () => false
    }
  },
  methods: {
    getAnswer() {
      let answer = [];
      for (let i = 0; i < this.data.values.length; i++) {
        let answerObject = {};

        answerObject = {
          questionnaireId: +localStorage.getItem("questionareId"),
          questionId: this.questionId,
          optionId: this.data.values[i] || null
        };

        Object.assign(
          answerObject,
          this.data.values[i]
            ? { answer: 1 }
            : { answerText: this.data.otherValue }
        );
        answer.push(answerObject);
      }
      if (!answer.length && this.isRequired) {
        this.data.errors = 1;
      }
      return answer;
    },
    closeErrorPopup() {
      this.data.errors = 0;
    }
  }
};
</script>

<style scoped></style>
